import { BaseEnv } from '@aipb/gulliver/env/model';
import { inject, Injectable } from '@angular/core';
import { SetupHandler } from './setup.handler';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { FooterReferenceComponent } from '../core/footer-reference/footer-reference.component';

@Injectable({
  providedIn: 'root'
})
export class FooterReferenceHandler extends SetupHandler {
  private overlay = inject(Overlay);

  constructor() {
    super('footer-reference.handler');
  }

  handle(env: BaseEnv) {
    if (!env.footerReference) return;

    const overlayRef = this.overlay.create({
      positionStrategy: this.overlay.position().global().bottom('0px').right('25px')
    });
    const portal = new ComponentPortal(FooterReferenceComponent);
    const componentRef = overlayRef.attach(portal);
    componentRef.instance.content = env.footerReference;
    this.addLogMessage(`add overlay with footer reference ${env.footerReference}`);
  }
}
